import { post, postJson, deleteApi, put, get, imagePost, putJson,postBlob } from './axios3'

import { putOne } from './axios2'

const RESOURCE_BASE_PATH = '/paradiseAndTaskCommon';

const RESOURCE_BASE_PATH2 = '/pointsExchange';

const RESOURCE_BASE_PATH3 = '/image';

const RESOURCE_BASE_PATH4 = '/PointActivityAnalyticController';

const RESOURCE_BASE_PATH5 = '/bigTurntableDraw';

const RESOURCE_BASE_PATH6 = '/order-lottery';

// 积分锁权
const RESOURCE_BASE_PATH7 = '/lockRight';

// 分页获取活动列表(积分任务和积分乐园)
export const taskList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

// 获取活动域名
export const prefixurl = p => get(`${RESOURCE_BASE_PATH}/prefixurl`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)  
export const exchangeActivityList = p => postJson(`${RESOURCE_BASE_PATH2}/exchangeActivityList`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const setActivityList = p => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const setActivityVenderType = p => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 创建礼品兑换活动-京豆
export const setActivityListBean = p => postJson(`${RESOURCE_BASE_PATH2}`, p);



// 删除礼品兑换活动列表(兑换优惠券和兑换实物)
export const deleteActivityList = id => deleteApi(`${RESOURCE_BASE_PATH2}/${id}`);

// 查询详情
export const inquireActivity = id => get(`${RESOURCE_BASE_PATH2}/${id}`);

// 修改详情
export const changeActivity = p => put(`${RESOURCE_BASE_PATH2}`, p);

// 上架下架礼品兑换
export const updateActivityList = p => put(`${RESOURCE_BASE_PATH2}/status/${p.id}?status=${p.status}`);

// 上传图片
export const uploadpic = p => imagePost(`${RESOURCE_BASE_PATH3}/upload`, p);

//标记发货
export const changeStatus = id => post(`${RESOURCE_BASE_PATH4}/markDeliveryStatus?id=${id}`);

//幸运抽奖
export const bigTurntableDraw = p => postJson(`${RESOURCE_BASE_PATH5}`, p);

//修改幸运抽奖
export const modifyBigTurn = p => putOne(`${RESOURCE_BASE_PATH5}`, p);

//幸运抽奖详情
export const getbigTurn = id => get(`${RESOURCE_BASE_PATH5}/${id}`);

//积分锁权 创建
export const addLockRight = p => postJson(`${RESOURCE_BASE_PATH7}/createActivity`, p);

//积分锁权 修改
export const modifyLockRight = p => putOne(`${RESOURCE_BASE_PATH7}/updateActivity`, p);

//积分锁权 详情
export const getLockRight = id => get(`${RESOURCE_BASE_PATH7}/detail/${id}`);

//下单有礼
export const bigTurntableDraw2 = p => postJson(`${RESOURCE_BASE_PATH6}/save`, p);
//下单有礼详情
export const getOrderDraw = id => get(`${RESOURCE_BASE_PATH6}/get/${id}`);

//  人群
export const getPersonLabelList = id => get(`/giftBag/getPersonLabelList`);

// 创建开卡礼包
export const createShopGift = p => postJson(`/giftBag/createShopGift`,p);

// 获取礼包活动下单转化数据
export const getShopGif = p => get(`/giftBag/getShopGiftParticipateConver`,p);


// 获取礼包模板列表数据
export const getGiftBagTemplate = p => get(`/giftBag/getGiftBagTemplate`,p);
// 获取礼包模板列表数据 分类 开卡 店铺 千人千面
export const getGiftBagList = p => get(`/giftBag/dir/list/${p}`);

// 修改礼包
export const editShopGift = p => postJson(`/giftBag/editShopGift`,p);

// 修改进行中的礼包
export const newupdateCommon = p => postJson(`/paradiseAndTaskCommon/activity/updateCommon`,p);

// 获取x详情   /jd-yusms-admin/giftbag/template/page
export const giftBagEide = id => get(`/giftBag/${id}`);

export const getValidActivity = p => get(`/giftBag/getValidActivity`)

// 创建店铺礼包千人千面
export const createThousandGift = p => postJson(`/giftBag/createThousandGift`, p);

// 修改店铺礼包千人千面
export const editThousandGift = p => postJson(`/giftBag/editThousandGift`, p);

// 千人千面  查询 
export const thousandGiftDetail = id => get(`/giftBag/thousandGiftDetail/${id}`)

//首购 复购 下单有礼 创建
export const createPurchaseActivity = p => postJson(`/purchaseActivity/create`, p);

// 首购 复购 下单有礼  查询 
export const purchaseActivityDetail = id => get(`/purchaseActivity/${id}`,)

// 首购 复购 下单有礼  修改 
export const editPurchaseActivity = p => putOne(`/purchaseActivity/edit`,p)

// 云短信过期时间
export const publicOpen = id => get(`/public/open/jd-crm`,)

// 创建评价有礼任务
export const commentCreate = p => postJson(`/comment/create`, p)

// 查询 评价有礼任务
export const getComment = id => get(`/comment/${id}`,)

//评价有礼任务 修改 
export const editCommentCreate = p => putOne(`/comment/edit`, p)

// 创建 裂变任务
export const splitCouponCreate = p => postJson(`/splitCoupon/save`, p)

// 查询 裂变任务
export const getSplitCoupon = id => get(`/splitCoupon/${id}`,)

//裂变任务 修改 
export const editSplitCoupon = p => postJson(`/splitCoupon/edit`,p)

// 创建 红包雨任务
export const redPacketCreate = p => postJson(`/red_packet_rain/save`, p)

// 查询 红包雨任务
export const getredPacket = id => get(`/red_packet_rain/details/${id}`,)


// 创建 抓娃娃  大家来找茬任务
export const createGameHub = p => postJson(`/gameHub/create`, p)

// 修改 抓娃娃  大家来找茬任务
export const editGameHub = p => putJson(`/gameHub/edit`, p)

// 查询 抓娃娃  大家来找茬任务
export const getGameHub = id => get(`/gameHub/${id}`,)

// 查询 大家一起来找擦模板集合/jd-hd-web/
export const getGameTemplate = id => get(`/gameHub/gameTemplate`,)

// 创建 创建预售有礼活动
export const createPresell = p => postJson(`/presell-activity/create`, p)

// 编辑 创建预售有礼活动/jd-hd-web/presell-activity/{id}
export const editPresell = p => postJson(`/presell-activity/edit`, p)

// 详情 预售有礼活动/jd-hd-web/
export const getPresell = p => get(`/presell-activity/${p}`)

// 创建 创建预售抽奖/jd-hd-web/
export const getlottery= p => get(`/presell-lottery/get/${p}`)

// 创建 创建预售抽奖/
export const createlottery = p => postJson(`/presell-lottery/save`, p)

// /jd-point/pointsExchange/{type}/{itemId}
export const hdTaskTemplateGroup = p => get(`/suspendingIcon/hdTask/getSystemTemplateGroup`, p)

// 创建E卡
export const pointsEcard = p => postJson(`/pointsExchange/ecard`, p)

// 创建京豆
export const pointsBean = p => postJson(`/pointsExchange/bean`, p)

// 查总数
export const pointsExchange = p => get(`/pointsExchange/${p.type}/${p.itemId}`,)

// 查总数京豆
export const accountBalance = p => get(`/beansPlan/accountBalance`,p)
// 刮刮乐
export const saveScratchers = p => postJson(`/scratchers/saveOrUpdate`, p)
// 刮刮乐详情
export const editScratchers = p => get(`/scratchers/${p}`)
// 海报/
export const saveSmartPost = p => postJson(`/smart-post/saveOrUpdate`, p)

// 海报详情/jd-hd-web/
export const editSmartPost = p => get(`/smart-post/${p}`)

// id查活动时间
export const getActivityInfoFromUrl = p => get(`/smart-post/getActivityInfoFromUrl/`,p)

//海报刮刮图片分类
export const getSystemTemplateGroup = id => get(`/suspendingIcon/smartCard/getSystemTemplateGroup`, id)
//海报刮刮图片图片
export const sellerImage = p => postJson(`/sellerImage/list`, p)

//海报刮刮图片图片
export const zdImage = p => postJson(`/sellerImage`, p)

export const getmoble = p => get(`/seller/current`, p);

export const getSellerCheckCode = p => get(`/seller/getSellerCheckCode`,p);

export const exportRecord = p => postBlob(`/jd-hd-web/PointActivityAnalyticController/exportExchangeActivityRecord`, p)

export const memberImproveRecords = p => postBlob(`/jd-hd-web/PointActivityEffectDetails/memberImproveRecords/export`, p)


export const activityDetail = p => get(`/paradiseAndTaskCommon/activity/detail`, p);

export const exportBatch = p => postBlob(`/jd-hd-web/pointsExchange/exportBatch`, p)


// 获取超级裂变券活动详情
export const editSplitSuper = p => get(`/super-splitCoupon/${p}`)
// 创建超级裂变券活动
export const SplitSuperSave = p => postJson(`/super-splitCoupon/save`, p)

// 修改超级裂变券活动
export const SplitSuperEdit = p => putJson(`/super-splitCoupon/edit`, p)

// 获取用户身份列表
export const getInviteeTypes = p => get(`/super-splitCoupon/getInviteeTypes`)

// 保存修改活动-会员卡片
export const memberCardSave = p => postJson(`/memberCard/saveOrUpdate`, p)
// 详情接口-会员卡片
export const memberCardList = p => get(`/memberCard/${p}`)
// 保存修改活动-会员卡片
export const freeTrialSave = p => postJson(`/freeTrial/saveOrUpdate`, p)
// 详情接口-会员卡片
export const freeTrialCardList = p => get(`/freeTrial/${p}`)


//打榜有礼---start

//创建活动接口
export const createOrderRank = p => postJson(`/order-rank/create`, p)

//查询 
export const orderRankDetail = id => get(`/order-rank/detail/${id}`,)

//修改 
export const updateOrderRank = p => putOne(`/order-rank/update`,p)

//兑换明细 
export const getExchangeActivityRecord = p => postJson(`/PointActivityAnalyticController/getExchangeActivityRecord`, p);

// 兑换明细导出
export const exportBatchDetail = p => postBlob(`/pointsExchange/exportBatch`, p)

// 录入快递单号
export const markingSendStatus = p => postJson(`/PointActivityAnalyticController/markingSendStatus`, p);

//---end

// 创建生日有礼活动
export const createBirthDayGift = p => postJson(`/BirthDayGiftController/createBirthDayGift`, p)

// 编辑生日有礼活动
export const updateBirthDayGift = p => postJson(`/BirthDayGiftController/updateBirthDayGift`, p)

// 生日有礼活动详情
export const getBirthDayDetail = id => get(`/BirthDayGiftController/detail/${id}`)

// 生日有礼-实物奖品中奖名单
export const goodRecords = p => get(`/PointActivityEffectDetails/goodRecords`,p)

// 生日有礼- 领取记录
export const getUnlockRecord = p => get(`/PointActivityEffectDetails/pointActivityPrizeDetail`, p);

//创建红包兑换活动接口
export const createRedPacket = p => postJson(`/pointsExchange/redPacket`, p)

// 创建积分锁权
export const pointLockSave = p => postJson(`/pointLock/save`, p)

// 积分锁权详情
export const getPointLockDetail = id => get(`/pointLock/detail/${id}`)

// 定时开奖活动保存
export const timePrizeSave = p => postJson(`/timePrize/save`, p)

// 定时开奖活动详情
export const getTimePrizeDetail = id => get(`/timePrize/detail/${id}`)


// 创建会员升级礼活动
export const saveMemberLevelGift = p => postJson(`/memberLevelGift/save`, p)

// 获取会员升级礼活动
export const getMemberLevelGift = id => get(`/memberLevelGift/detail/${id}`)

// 获取会员等级权益
export const getMemberBenefitInfo = p => postJson(`/memberBenefit/getMemberBenefitInfo`, p)

// 订单明细
export const orderDetailPage  = p => get(`/PointActivityEffectDetails/orderDetailPage`, p);

// 入会用户转化分析
export const memConvAnalysis  = p => postJson(`/PointActivityEffectDetails/memConvAnalysis`, p);

// 积分活动白名单分页接口
export const pointActivityWhite = p => get(`/pointActivityWhite/page`, p)

// 积分活动新增或更新白名单接口
export const pointActivityAddOrUpdate = p => postJson(`/pointActivityWhite/saveOrUpdateWhite`, p)

// 数据分析-中奖记录-奖品发放总览
export const prizeSum = p => get(`/PointActivityEffectDetails/prizeSum`, p)

// 活动管理-积分兑换-修改兑换活动接口
export const updateActivity = p => postJson(`/pointsExchange/updateActivity`, p)

// 活动管理-积分兑换-保存商城模板接口
export const saveEchange = p => postJson(`/decorationInfo/exchange`, p)

// 活动管理-积分兑换-查询商城装修模板
export const getDecorationInfoDetail = p => get(`/decorationInfo/exchange/detail`, p)

// 撤回奖品
export const purchaseActivityWithdraw = p => postJson(`/purchaseActivity/withdraw`, p)

// 修改中奖记录奖品名称记录列表接口
export const freeGiftEditLog = p => get(`/freeGift/winRecord/editLog`, p)

//派样付款列表随单发
export const expotrPromoSendReBuy = p => postBlob(`/jd-hd-web/promoSendReBuy/payOrder/export`, p)

//令牌赠品发放记录导出
export const expotrPromoSendReBuytokenRecord = p => postBlob(`/jd-hd-web/promoSendReBuy/tokenRecord/export`, p)

//派样回购对标商品导出
export const benchmarkingExport = p => postBlob(`/jd-hd-web/promoSendReBuy/benchmarking/export`, p)

// 活动管理-中奖查询-根据pin获取中奖记录
export const getWinRecordByPin = p => postJson(`/pointActivity/getWinRecordByPin`, p)

/**
 * 活动管理-满额有礼-参与记录列表查询
 * @param {*} p 
 * @returns 
 */
export const getJoinRecordList = p => postJson(`/fullGift/joinRecordPage`, p);

/**
 * 活动管理-满额有礼-参与记录导出
 * @param {*} p 
 * @returns 
 */
export const exportAllInfo = (p) => postJson(`/fullGift/joinRecordExport`, p)

// 京东0元试用活动创建、编辑
export const createTrialActivity = p => postJson('/trialActivity/save', p)

// 京东0元试用活动详情
export const getTrialActivityDetail = p => get(`/trialActivity/detail/${p}`)
/**
 * 情书贺卡相关接口
 */

// 创建/更新 情书贺卡活动
export const saveBilletDoux = p => postJson(`/LoveLetterGreetingCardController/saveActivity`, p)

// 获取情书贺卡活动详情
export const getBilletDouxDetail = id => get(`/LoveLetterGreetingCardController/detail/${id}`)

/**
 * 小部件-小
 */

// 创建/更新 情书贺卡活动
export const saveCardSmall = p => postJson(`/activityCard/saveOrUpdate`, p)

// 获取情书贺卡活动详情
export const getCardSmallDetail = id => get(`/activityCard/detail/${id}`) 

// 实物名单-订单明细
export const getOrderRrankorderDetail = p => get('/order-rank/orderDetail',p)
// 创建积分加钱购活动
export const addMoneyActivity = p => postJson('/pointsExchange/addMoney', p)

// 积分加钱购-撤回
export const quashAddMoney = p => put(`/pointsExchange/addMoney/quash?id=${p.id}`)

// 满赠有礼活动详情
export const fullGiftDetail = (p) => get(`/fullGift/detail/${p}`);

// 集卡有礼保存或更新接口
export const saveCollectCard = p => postJson('/collectCard/saveOrUpdate', p)

// 集卡有礼详情接口
export const getCollectCardDetail = p => get('/collectCard/detail', p)
// 创建兑换活动(爱奇艺会员、京东plus、礼品卡、百度网盘)
export const createPointsExchangeGift = p => postJson('/pointsExchange/gift', p)

//BI店铺礼包创建
export const createBiStoreGift = p => postJson('/giftBag/createBiShopGift', p)

//修改店铺礼包
export const editBiStoreGift = p => postJson('/giftBag/editBiShopGift', p)


//BI店铺礼包详情
export const getBiStoreGiftDetail = id => get(`/giftBag/biShopGiftDetail/${id}`) 

//黑名单列表
export const getBlacklist = p => get('/order-rank/blacklist', p)

//新增黑名单
export const addBlacklist = p => postJson('/order-rank/blacklist', p)

//删除黑名单
export const deleteBlacklist = id => deleteApi(`/order-rank/blacklist/${id}`)

//参与记录-拼团砍价
export const participateRecord = p => get(`/groupBargain/participateRecord`,p)

//参与记录导出-拼团砍价
export const participateRecordExport = p => postJson(`/groupBargain/participateRecord/export`,p)

//砍价记录导出-拼团砍价
export const bargainRecordExport = p => postJson(`/groupBargain/bargainRecord/export`,p)

//砍价记录-拼团砍价
export const getBargainRecord = p => get(`/groupBargain/bargainRecord`,p)

//查看竞价活动列表
export const getAuctionActivityList = p => postJson(`${RESOURCE_BASE_PATH}/pointAuction/page`, p);

export const updateAct= p => postJson(`/paradiseAndTaskCommon/activity/update`, p)

// 登记生日信息查询
export const getBirthdayInfo = p => get(`/BirthDayGiftController/getBirthdayInfo`,p)

//获取礼包详情接口
export const giftBagDetails = id => get(`/giftBag/detail/${id}`) 
// 时光许愿池参与记录分页
export const getTimeWishPoolPage = p => postJson('/timeWishPool/participation/page', p)

// 时光许愿池参与记录导出
export const getTimeWishPoolExport = p => postJson('/timeWishPool/participation/export', p)
// 商品明细统计
export const getSkuDetailStats = p => postJson(`/PointActivityEffectDetails/skuDetailStats`, p)

// 商品明细统计导出
export const getSkuDetailStatsExport = p => postJson(`/PointActivityEffectDetails/skuDetailStats/export`, p)

// 盖楼有礼-参与记录
export const getBuildingGiftPage = p => postJson('/buildingGift/joinRecord', p)

// 盖楼有礼-参与记录导出
export const getBuildingGiftExport = p => postJson('/buildingGift/joinRecord/export', p)

// 小红书晒单礼-参与记录
export const getXhsJoinRecord = p => postJson('/redNoteShowGift/joinRecord', p)

// 小红书晒单礼-参与记录导出
export const getXhsJoinRecordExport = p => postJson('/redNoteShowGift/joinRecord/export', p)

// 小红书晒单礼-AI资源汇总
export const getXhsAIGeneratedSummary = p => get('/redNoteShowGift/aiRemainingNumber', p)

// 小红书晒单礼-AI资源列表
export const getXhsAIGeneratedList = p => get('/redNoteShowGift/aiGeneratedRecord', p)

// 生成AI文案
export const aiGenerate = p => postJson('/redNoteShowGift/aiGenerate', p);

// 查询AI生成结果
export const aiGenerateResult = p => get('/redNoteShowGift/aiGenerateResult', p);

// 导出AI生成结果明细
export const aiGenerateDetailExport = p => postJson('/redNoteShowGift/aiGenerateDetail/export?recordId=' + p.recordId)

// 集分冲榜-参与记录
export const getScoreRankJoinRecord = p => postJson('/scoreRank/joinRecord', p)

// 集分冲榜-参与记录导出
export const getScoreRankJoinRecordExport = p => postJson('/scoreRank/joinRecord/export', p)

// 日历打卡-参与记录
export const getCalendarCheckInJoinRecord = p => postJson('/calendarCheckCardActivity/joinRecord', p)

// 日历打卡-参与记录导出
export const getCalendarCheckInJoinRecordExport = p => postJson('/calendarCheckCardActivity/joinRecord/export', p)

// 日历打卡任务-打卡明细
export const getCalendarCheckInDetail = p => postJson('/calendarCheckCardActivity/calendarCheckCard/details', p)

//日历打卡任务-打卡明细-导出
export const getCalendarCheckInDetailExport = p => postJson('/calendarCheckCardActivity/calendarCheckCard/details/export', p)

//查询分页数据、已有商品数量
export const getFunnyQuizProductPage = p => postJson('/funnyQuizProduct/page', p)

// 删除商品商品
export const deleteFunnyQuizProduct = p => get('/funnyQuizProduct/delete', p)

// 手动添加推荐商品
export const addFunnyQuizProduct = p => postJson('/funnyQuizProduct/add', p)

// 更换商品
export const replaceFunnyQuizProduct = p => postJson('/funnyQuizProduct/replace', p)

// 设置标签（编辑）
export const setLabelsEdit = p => postJson('/funnyQuizProduct/setLabels', p)

// 批量导入商品
export const batchImportGoods = p => imagePost('/funnyQuizProduct/import', p)

// 获取已经添加的商品数量
export const getFunnyQuizProductCount = p => get('funnyQuizProduct/count', p)
// 数据分析-订单明细-数据概览
export const orderDetailPageDataOverview = p => get('/PointActivityEffectDetails/orderDetailPage/dataOverview', p)
// 百变趣答录-参与记录
export const getVersatileAnswersJoinRecord = p => postJson('/funnyQuestion/joinRecord', p)

// 百变趣答录-参与记录导出
export const getVersatileAnswersJoinRecordExport = p => postJson('/funnyQuestion/joinRecord/export', p)

// Bi_店铺订单明细
export const getBiOrderDetailPage = p => get('/giftBag/orderDetailPage', p)

// 保存内容模板
export const saveContentTemplate = p => postJson('/redNoteShowGift/template/save', p)

// 分页查询内容模板
export const getContentTemplatePage = p => get('/redNoteShowGift/template/page', p)

// 删除内容模板
export const deleteContentTemplate = p => get('/redNoteShowGift/template/delete', p)
// 问答指南-参与记录
export const getAnswerGuideJoinRecord = p => postJson('/answerGuide/joinRecord', p)

// 问答指南-参与记录导出
export const getAnswerGuideJoinRecordExport = p => postJson('/answerGuide/joinRecord/export', p)

// 问答指南-推荐商品-分页
export const getAnswerGuideRecommendProductPage = p => postJson('/answerGuide/recommendProduct/page', p)

// 问答指南-推荐商品-导出
export const getAnswerGuideRecommendProductExport = p => postJson('/answerGuide/recommendProduct/export', p)

// 导出积分兑换优惠券-参与记录
export const exportPointsRedemptionCoupon = p => postJson('/PointActivityEffectDetails/exportPointActivityPrizeDetail', p)

export const getTrialRebuyOrderDetailDataOverview = p => get('/trialRebuy/orderDetail/dataOverview', p)

// 数据分析-订单明细
export const pointOrderDetailPage = p => get('/PointActivityAnalyticController/orderDetailPage', p)

// 数据分析-订单明细-数据概览
export const pointOrderDetailPageDataOverview = p => get('/PointActivityAnalyticController/orderDetailPage/dataOverview', p)

// 白名单上传文件通用接口
export const uploadWhiteListFile = (type,p) => postJson(`/public/upload/file/${type}`, p)

// 删除白名单
export const deleteWhiteList = p => postJson('/pointActivityWhite/deleteWhite', p)
